import { render, staticRenderFns } from "./programa-integrado-con-registro.vue?vue&type=template&id=ec9d107c&"
import script from "./programa-integrado-con-registro.component.ts?vue&type=script&lang=ts&"
export * from "./programa-integrado-con-registro.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports